module.exports = __webpack_public_path__ + "static/media/myBet_3.85a6232a.mp3";